import { Box, Tooltip, Typography } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";

const ActionsCell = ({
  params,
  setSelectedNotification,
  setOpenDeleteNotification,
  setOpenViewUsersModal,
  setSelectedNotificationForUsers,
}) => {
  const navigate = useNavigate();

  const handleEdit = () => {
    // Pass the entire notification object
    navigate(`/custom-notifications/edit/${params.row.id}`, {
      state: { notification: params.row },
    });
  };

  const handleDelete = () => {
    setSelectedNotification(params.row);
    setOpenDeleteNotification(true);
  };

  const handleViewUsers = () => {
    setSelectedNotificationForUsers(params.row);
    setOpenViewUsersModal(true);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1, // Keep a small gap for a tighter layout
        height: "100%",
        minHeight: "52px",
      }}
    >
      {/* View Details Button */}
      <Box
        display="flex"
        alignItems="center"
        sx={{
          backgroundColor: "#FAFAFA",
          borderRadius: "6px",
          border: "1px solid #E0E0E0",
          padding: "4px 0",
          gap: 1,
        }}
      >
        <Tooltip title="View Details">
          <Box
            display="flex"
            alignItems="center"
            sx={{
              cursor: "pointer",
              padding: "4px 8px",
              borderRadius: "4px",
              "&:hover": {
                backgroundColor: "#F0F0F0",
              },
            }}
            onClick={handleViewUsers}
          >
            <VisibilityIcon fontSize="small" color="primary" />
            <Typography
              variant="body2"
              sx={{
                ml: 1,
                fontSize: "13px",
                fontWeight: 500,
                color: "#1976D2",
              }}
            >
              View Details
            </Typography>
          </Box>
        </Tooltip>
      </Box>

      {/* Edit Button - Conditionally visible with icon and text */}
      {params.row.allow_update === 1 && (
        <>
          <Box
            sx={{
              height: "20px",
              width: "1px",
              backgroundColor: "#E0E0E0",
            }}
          />
          <Box
            display="flex"
            alignItems="center"
            sx={{
              backgroundColor: "#FAFAFA",
              borderRadius: "6px",
              border: "1px solid #E0E0E0",
              padding: "4px 0",
              gap: 1,
            }}
          >
            <Tooltip title="Edit">
              <Box
                display="flex"
                alignItems="center"
                sx={{
                  cursor: "pointer",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  "&:hover": {
                    backgroundColor: "#F0F0F0",
                  },
                }}
                onClick={handleEdit}
              >
                <EditIcon fontSize="small" color="primary" />
                <Typography
                  variant="body2"
                  sx={{
                    ml: 1,
                    fontSize: "13px",
                    fontWeight: 500,
                    color: "#1976D2",
                  }}
                >
                  Edit
                </Typography>
              </Box>
            </Tooltip>
          </Box>
        </>
      )}

      {/* Delete Button - Conditionally visible with icon and text */}
      {params.row.allow_delete === 1 && (
        <>
          <Box
            sx={{
              height: "20px",
              width: "1px",
              backgroundColor: "#E0E0E0",
            }}
          />
          <Box
            display="flex"
            alignItems="center"
            sx={{
              backgroundColor: "#FAFAFA",
              borderRadius: "6px",
              border: "1px solid #E0E0E0",
              padding: "4px 8px",
              gap: 1,
            }}
          >
            <Tooltip title="Delete">
              <Box
                display="flex"
                alignItems="center"
                sx={{
                  cursor: "pointer",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  "&:hover": {
                    backgroundColor: "#F0F0F0",
                  },
                }}
                onClick={handleDelete}
              >
                <DeleteForeverIcon fontSize="small" color="error" />
                <Typography
                  variant="body2"
                  sx={(theme) => ({
                    ml: 1,
                    fontSize: "13px",
                    fontWeight: 500,
                    color: theme.palette.error.main,
                  })}
                >
                  Delete
                </Typography>
              </Box>
            </Tooltip>
          </Box>
        </>
      )}
    </Box>
  );
};

export default ActionsCell;
